// src/redux/reducer.js
import {
  FETCH_DATA_REQUEST,
  FETCH_DATA_SUCCESS,
  FETCH_DATA_FAILURE,
  SET_DATE,
  FETCH_REALTIME_LINE_ACTIVITY_REQUEST,
  FETCH_REALTIME_LINE_ACTIVITY_SUCCESS,
  FETCH_REALTIME_LINE_ACTIVITY_FAILURE,
  REAL_TIME_LINE_ACTIVITY_NON_SEED_REQUEST,
  REAL_TIME_LINE_ACTIVITY_NON_SEED_SUCCESS,
  REAL_TIME_LINE_ACTIVITY_NON_SEED_FAILURE,
  FETCH_REALTIME_WAREHOUSE_ACTIVITY_REQUEST,
  FETCH_REALTIME_WAREHOUSE_ACTIVITY_SUCCESS,
  FETCH_REALTIME_WAREHOUSE_ACTIVITY_FAILURE,
  FETCH_REALTIME_WAREHOUSE_LINE_REQUEST,
  FETCH_REALTIME_WAREHOUSE_LINE_SUCCESS,
  FETCH_REALTIME_WAREHOUSE_LINE_FAILURE,
  FETCH_REALTIME_WAREHOUSE_COUNT_REQUEST,
  FETCH_REALTIME_WAREHOUSE_COUNT_SUCCESS,
  FETCH_REALTIME_WAREHOUSE_COUNT_FAILURE,
  DRIER_STATUS_REQUEST,
  DRIER_STATUS_SUCCESS,
  DRIER_STATUS_FAILURE,
  FETCH_DRIER_STATUS_REPORT_ODD_FAILURE,
  FETCH_DRIER_STATUS_REPORT_ODD_SUCCESS,
  FETCH_DRIER_STATUS_REPORT_ODD_REQUEST,
  FETCH_DRIER_STATUS_REPORT_EVEN_FAILURE,
  FETCH_DRIER_STATUS_REPORT_EVEN_SUCCESS,
  FETCH_DRIER_STATUS_REPORT_EVEN_REQUEST,
  FETCH_WAREHOUSE_STATUS_FAILURE,
  FETCH_WAREHOUSE_STATUS_SUCCESS,
  FETCH_WAREHOUSE_STATUS_REQUEST,
  FETCH_WAREHOUSE_STATUS_LINE_SEED_REQUEST,
  FETCH_WAREHOUSE_STATUS_LINE_SEED_SUCCESS,
  FETCH_WAREHOUSE_STATUS_LINE_SEED_FAILURE,
  FETCH_WAREHOUSE_STATUS_LINE_NON_SEED_REQUEST,
  FETCH_WAREHOUSE_STATUS_LINE_NON_SEED_SUCCESS,
  FETCH_WAREHOUSE_STATUS_LINE_NON_SEED_FAILURE,
  FETCH_DRYING_TRANSACTION_TEMP_REQUEST,
  FETCH_DRYING_TRANSACTION_TEMP_SUCCESS,
  FETCH_DRYING_TRANSACTION_TEMP_FAILURE,
  FETCH_ORGANIZATION_FAILURE,
  FETCH_ORGANIZATION_SUCCESS,
  FETCH_ORGANIZATION_REQUEST,
} from "./actionTypes";
import { initialState } from "./initialState";

const reportReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case FETCH_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: "",
      };
    case FETCH_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        data: [],
        error: action.payload,
      };
    case SET_DATE:
      return {
        ...state,
        currentDate: action.payload,
      };

    case FETCH_REALTIME_LINE_ACTIVITY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null, // Clear any previous errors
      };

    case FETCH_REALTIME_LINE_ACTIVITY_SUCCESS:
      return {
        ...state,
        loading: false,
        realTimeLineActivityData: action.payload.data, // Update data
        error: null,
      };

    case FETCH_REALTIME_LINE_ACTIVITY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload, // Store the error
      };
    case REAL_TIME_LINE_ACTIVITY_NON_SEED_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case REAL_TIME_LINE_ACTIVITY_NON_SEED_SUCCESS:
      return {
        ...state,
        loading: false,
        realTimeLineActivityNonSeed: action.payload.data,
      };
    case REAL_TIME_LINE_ACTIVITY_NON_SEED_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case FETCH_REALTIME_WAREHOUSE_ACTIVITY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_REALTIME_WAREHOUSE_ACTIVITY_SUCCESS:
      return {
        ...state,
        loading: false,
        realTimeWarehouseActivity: action.payload,
        error: null,
      };

    case FETCH_REALTIME_WAREHOUSE_ACTIVITY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // 📌 Warehouse Line Reducer
    case FETCH_REALTIME_WAREHOUSE_LINE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_REALTIME_WAREHOUSE_LINE_SUCCESS:
      return {
        ...state,
        loading: false,
        realTimeWarehouseLine: action.payload,
        error: null,
      };

    case FETCH_REALTIME_WAREHOUSE_LINE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // 📌 Warehouse Count Reducer
    case FETCH_REALTIME_WAREHOUSE_COUNT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_REALTIME_WAREHOUSE_COUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        realTimeWarehouseCount: action.payload,
        error: null,
      };

    case FETCH_REALTIME_WAREHOUSE_COUNT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DRIER_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case DRIER_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        drierStatusReport: action.payload,
        error: null,
      };

    case DRIER_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case FETCH_DRIER_STATUS_REPORT_EVEN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_DRIER_STATUS_REPORT_EVEN_SUCCESS:
      return {
        ...state,
        loading: false,
        drierStatusReportEven: action.payload,
      };
    case FETCH_DRIER_STATUS_REPORT_EVEN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case FETCH_DRIER_STATUS_REPORT_ODD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_DRIER_STATUS_REPORT_ODD_SUCCESS:
      return {
        ...state,
        loading: false,
        drierStatusReportOdd: action.payload,
      };
    case FETCH_DRIER_STATUS_REPORT_ODD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

      case FETCH_DRYING_TRANSACTION_TEMP_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_DRYING_TRANSACTION_TEMP_SUCCESS:
      return {
        ...state,
        loading: false,
        DryingTransactionTemp: action.payload,
      };
    case FETCH_DRYING_TRANSACTION_TEMP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };


    case FETCH_WAREHOUSE_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_WAREHOUSE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        warehouseStatusData: action.payload,
      };
    case FETCH_WAREHOUSE_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

     // Seed Cases
     case FETCH_WAREHOUSE_STATUS_LINE_SEED_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_WAREHOUSE_STATUS_LINE_SEED_SUCCESS:
      return { ...state, loading: false, seedLines: action.payload };

    case FETCH_WAREHOUSE_STATUS_LINE_SEED_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Non-Seed Cases
    case FETCH_WAREHOUSE_STATUS_LINE_NON_SEED_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_WAREHOUSE_STATUS_LINE_NON_SEED_SUCCESS:
      return { ...state, loading: false, nonSeedLines: action.payload };

    case FETCH_WAREHOUSE_STATUS_LINE_NON_SEED_FAILURE:
      return { ...state, loading: false, error: action.payload };

      case 'RESET_REPORT_STATE':
        return initialState; // Reset state to initial


        // fetch org

// Reducer Cases
case FETCH_ORGANIZATION_REQUEST:
  return {
    ...state,
    loading: true,
    error: null,
  };

case FETCH_ORGANIZATION_SUCCESS:
  return {
    ...state,
    loading: false,
    organizationData: action.payload,
  };

case FETCH_ORGANIZATION_FAILURE:
  return {
    ...state,
    loading: false,
    error: action.payload,
  };
    default:
      return state;
  }
};

export default reportReducer;
